import { auth } from "../core";
import { reactive } from "vue";
import Enumerable from "linq";
import branchRoutes from "./admin/BranchRoutes";
import nyukyoshaRoutes from "./NyukyoshaRoutes";
import { UserKb, userType } from "~/extensions/utils/DefineTypes";
import headquartersRoutes from "./admin/HeadquartersRoutes";
import hojinRoutes from "./HojinRoutes";
export class RouteManager {
    callbacks = [];
    /**ルーターの初期化 */
    initRoute(router) {
        if (!auth.isAuthenticated) {
            return;
        }
        this.reset();
        if (auth.userInfo.userKbn === UserKb.Tenant) {
            if (auth.userInfo.userType === userType.hojin) {
                this.initHojin(router);
            }
            else {
                this.initNyukyosha(router);
            }
            return;
        }
        if (auth.userInfo.userKbn === UserKb.Mt) {
            if (auth.userInfo.isHeadquarters) {
                this.initHeadquarters(router);
            }
            else {
                this.initMinimini(router);
            }
        }
    }
    initMinimini(router) {
        Enumerable.from(branchRoutes).forEach(route => {
            let callback = router.addRoute("index", route);
            this.callbacks.push(callback);
        });
    }
    initHeadquarters(router) {
        Enumerable.from(headquartersRoutes).forEach(route => {
            let callback = router.addRoute("index", route);
            this.callbacks.push(callback);
        });
    }
    initNyukyosha(router) {
        Enumerable.from(nyukyoshaRoutes).forEach(route => {
            let callback = router.addRoute("index", route);
            this.callbacks.push(callback);
        });
    }
    initHojin(router) {
        Enumerable.from(hojinRoutes).forEach(route => {
            let callback = router.addRoute("index", route);
            this.callbacks.push(callback);
        });
    }
    reset() {
        if (this.callbacks.length === 0) {
            return;
        }
        Enumerable.from(this.callbacks).forEach(callback => {
            callback();
        });
        this.callbacks = [];
    }
}
export const routeManager = reactive(new RouteManager());
